export const SET_REVIEWS = 'SET_REVIEWS'
export const SET_INCLUDES = 'SET_INCLUDES'

export const setReviews = (reviews: any[]) => ({ type: SET_REVIEWS, payload: reviews })
export const setIncludes = (includes: any[]) => ({ type: SET_INCLUDES, payload: includes })
